import './style.scss';

const Avatar = ({ children, className, ...props }: any) => {
  return (
    <div
      className="avatar rounded-circle border d-flex justify-content-center align-items-center bg-primary"
      {...props}>
      <span className="text-white">{children}</span>
    </div>
  );
};

export default Avatar;
